export default __webpack_public_path__ + "static/media/venori_no_image.1f4b6c0c.webp";